module.exports = __webpack_public_path__ + "img/buc_osama_kl.86a51e10.jpg";